import axiosInstance from 'api/axiosInstance';
import { URL_CANDISPATCH_READ_ADDRESS } from 'constants/urls';

const getAddress = async (id: number) => {
  try {
    const { data } = await axiosInstance.get(
      `${URL_CANDISPATCH_READ_ADDRESS}?id=${id}`,
    );
    return data;
  } catch (error) {
    console.error('[getAddress] Failed:', error);
    throw error;
  }
};

export default getAddress;
